module.exports = __webpack_public_path__ + "42befe0a5ba319d06df1a84f9b6b7141.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/close.png
// module id = 20
// module chunks = 0 1 2 3